const SLASH = '/';

/**
 * Add atrailing slashs to any url string
 * @param {string} url - any usrl
 * @example
 * normaliseTrailingSlash('foo/bar') => 'foo/bar/'
 */
export default function normaliseTrailingSlash(url) {
    return url[url.length - 1] === SLASH ? url : `${ url }/`;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/normalise-trailing-slash.js